import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import exportFromJSON from "export-from-json";
import { JsonToExcel } from "react-json-to-excel";
import PdfGenerater from "./PdfGeneratorVessel";
import { getTimeStampForReports } from "../../utils/DataFormate";
import moment from "moment";
import DataNotFound from "../DataNotFound/DataNotFound";
import SpinerLoader from "src/utils/SpinerLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileCsv,
  faFileExcel,
  faFileCode,
} from "@fortawesome/free-solid-svg-icons";
import { languageJson } from "../../StringVariable";
import axios from "src/redux/actions/apis";
import { VESSEL_OPERATIONS_FOR_REPORTS_URL } from "../../url/Url";
//import { VESSEL_OPERATIONS_FOR_REPORTS_TEST_URL } from "../../url/Url";
import "./report.css";
const getTime = () => {
  const time = moment().tz("America/Los_Angeles");
  return time.isValid() ? time.format("L h:mm A") : "-";
};

function VesselReportsDataShortReport() {
  const [reportData, setReportData] = useState(null);
  const [exportList, setExportList] = useState([]);

  const { export_PDF_txt, export_Excel_txt, export_CSV_txt, export_XML_txt } =
    languageJson;

  useEffect(() => {
    getData();
  }, []);

  // const getData = async () => {
  //   setReportData(vesselReportData?.vessels || []);
  // };

  const getData = async () => {
    const res = await axios.get(VESSEL_OPERATIONS_FOR_REPORTS_URL);
    setReportData(res.data?.vessels || []);
  };

  const getSectionData = (section) => {
    return section.atBerth || section.atAnchorage || section.enroute || [];
  };

  const getColumns = (category) => {
    switch (category.toLowerCase()) {
      case "vessels at berth (arrived)":
        return ["Vessel Name", "Berth", "Terminal", "Arrived at Berth"];

      case "vessels at anchorage (inbound)":
        return [
          "Vessel Name",
          //   "Navigation Status",
          // "Berth",
          "Terminal",
          "Arrived at Anchor",
          "Projected Arrival (MTO Vessel Schedule)",
        ];

      case "vessels en route (< 48 hours)":
        return [
          "Vessel Name",
          "Terminal",
          "Projected Arrival (MTO Vessel Schedule)",
          // "First Available Date",
        ];

      default:
        return ["Vessel Name"];
    }
  };

  const formatDateTime = (date) =>
    date
      ? moment(date).tz("America/Los_Angeles").format("MM/DD/YYYY h:mm A")
      : "-";

  const formatRow = (item, category) => {
    switch (category.toLowerCase()) {
      case "vessels at berth (arrived)":
        return {
          "Vessel Name": item.vesselName || "-",
          Berth: item.berth || "-",
          Terminal: item.terminal || "-",
          "Arrived at Berth": formatDateTime(item.actualArrival),
        };

      case "vessels at anchorage (inbound)":
        return {
          "Vessel Name": item.vesselName || "-",
          "Navigation Status": item.navigationStatus || "-",
          //    Berth: item.berth || "-",
          Terminal: item.terminal || "-",
          "Arrived at Anchor": formatDateTime(item.actualArrival),
          "Projected Arrival (MTO Vessel Schedule)": formatDateTime(
            item.estimatedArrival
          ),
        };

      case "vessels en route (< 48 hours)":
        return {
          "Vessel Name": item.vesselName || "-",
          Terminal: item.terminal || "-",
          "Projected Arrival (MTO Vessel Schedule)": formatDateTime(
            item.estimatedArrival
          ),
          // "First Available Date": formatDateTime(
          //   item.firstAvailableOrReceivingDate
          // ),
        };

      default:
        return {
          "Vessel Name": item.vesselName || "-",
        };
    }
  };

  const fileName = `Vessel Schedules Report-${getTimeStampForReports().replace(
    /:/g,
    "-"
  )}`;

  const downloadXml = () => {
    exportFromJSON({
      data: exportList,
      fileName,
      exportType: "xml",
    });
  };

  // Run formatting data pipeline automatically or ensure the data handles gracefully
  // without relying explicitly on clicking a "prepare" button first.
  useEffect(() => {
    if (reportData && reportData.length > 0) {
      const formatted = [];
      reportData.forEach((section) => {
        formatted.push({
          "Vessel Name": `*** ${section.category.toUpperCase()} ***`,
        });
        const vessels = getSectionData(section);
        vessels.forEach((item) => {
          formatted.push(formatRow(item, section.category));
        });
        formatted.push({});
      });
      setExportList(formatted);
    }
  }, [reportData]);

  return (
    <div className="container">
      {/* Replaced single download button with the target download list layout directly */}
      {reportData !== null && reportData.length > 0 && (
        <div
          className="d-flex justify-content-end align-items-center"
          style={{
            width: "100%",
            marginTop: "-20px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            {/* <span style={{ fontWeight: "600", fontSize: "16px" }}>
              {download_options_txt}
            </span> */}

            <span title={export_PDF_txt}>
              <PdfGenerater
                reportData={reportData}
                buttonclassName={"pdfbutton"}
                buttonTitle={<FontAwesomeIcon icon={faFilePdf} size="lg" />}
                title={languageJson.vesselOperation_txt}
                fileName={`Vessel Schedules Report-${getTimeStampForReports().replace(
                  /:/g,
                  "-"
                )}`}
                formatRow={formatRow}
                getSectionData={getSectionData}
                size={"A1"}
              />
            </span>

            <span title={export_CSV_txt}>
              <CSVLink
                data={exportList}
                filename={`${fileName}.csv`}
                className="downloadBtny btn btn-primary downloadbutton"
              >
                <FontAwesomeIcon icon={faFileCsv} size="lg" />
              </CSVLink>
            </span>

            <span title={export_Excel_txt}>
              <JsonToExcel
                title={<FontAwesomeIcon icon={faFileExcel} size="lg" />}
                data={exportList}
                fileName={fileName}
                btnClassName="download-btn"
              />
            </span>

            <div title={export_XML_txt}>
              <button
                className="downloadBtny btn btn-primary downloadbutton"
                onClick={downloadXml}
              >
                <FontAwesomeIcon icon={faFileCode} size="lg" />
              </button>
            </div>
          </div>
        </div>
      )}
      {reportData === null ? (
        <SpinerLoader />
      ) : reportData.length === 0 ? (
        <DataNotFound />
      ) : (
        <>
          {reportData.map((section, idx) => {
            const category = section.category;
            const columns = getColumns(category);
            const vessels = getSectionData(section);

            return (
              <div key={idx} className="mt-4">
                <div
                  style={{
                    background: "#2c7b80",
                    textAlign: "center",
                    padding: "8px",
                    border: "1px solid black",
                    fontSize: "27px",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {section.category.toUpperCase()}
                </div>

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead style={{ background: "#b9d4ec" }}>
                    <tr>
                      {columns.map((col, i) => (
                        <th key={i} style={cell}>
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {vessels.length > 0 ? (
                      vessels.map((item, i) => {
                        const row = formatRow(item, category);

                        return (
                          <tr key={i}>
                            {columns.map((col, j) => (
                              <td key={j} style={cell}>
                                {row[col]}
                              </td>
                            ))}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={columns.length}
                          style={{
                            ...cell,
                            textAlign: "center",
                          }}
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            );
          })}
        </>
      )}

      {reportData !== null && reportData.length > 0 && (
        <div
          style={{
            background: "#2c7b80",
            textAlign: "center",
            padding: "12px",
            marginTop: "30px",
            marginBottom: "50px",
            border: "1px solid black",
            fontSize: "20px",
            color: "white",
          }}
        >
          Report Generated on <span>{getTime()}</span>
        </div>
      )}
    </div>
  );
}

const cell = {
  border: "1px solid black",
  padding: "8px",
};

export default VesselReportsDataShortReport;
